// Case API service for Literature Review
import { apiClient } from '../utils/api';

export interface LiteratureCaseData {
  title: string;
  url: string;
  snippet?: string;
  venue?: string;
  year?: number;
  authors_info?: string;
  doi?: string;
  analysis?: any;
  pharmacovigilanceData?: any;
}

export const createCasesFromResults = async (articles: LiteratureCaseData[]) => {
  try {
    const response = await apiClient.post('/api/literature/cases', {
      // Backend expects 'results' array with each item containing metadata + AI 'analysis'
      results: articles.map(article => ({
        title: article.title,
        url: article.url,
        snippet: (article as any).snippet,
        venue: (article as any).venue,
        year: (article as any).year,
        authors_info: (article as any).authors_info,
        doi: (article as any).doi,
        analysis: article.analysis,
        pharmacovigilanceData: article.pharmacovigilanceData,
      })),
    });
    return response.data;
  } catch (error) {
    console.error('Failed to create cases:', error);
    throw error;
  }
};

export default {
  createCasesFromResults
};
